module.exports = null



//////////////////
// WEBPACK FOOTER
// ./node_modules/empty-module/index.js
// module id = 557
// module chunks = 0